import React from 'react';
import PrimaryButton from '../Buttons/PrimaryButton';
import SecondaryButton from '../Buttons/SecondaryButton';
import ApproveButton from '../Buttons/ApproveRejectButton';
import SaveButton from '../Buttons/SaveButton';

const CardWithButton = ({
  button_type = 'primary',
  component_styles,
  data,
  oncClickHandler,
  onClickSkip,
  onMarkAsComplete,
}) => {
  return (
    <div
      className={`px-4 relative  md:px-8 py-4 pb-[60px] border border-gray-200 rounded space-y-3  bg-[#FAFBFB]  w-full ${component_styles}`}>
      <div className="flex-grow  ">
        <h1 className=" font-extralight  text-sm md:text-lg text-black">
          {data?.title}
        </h1>
        <p className="   text-xs md:text-base font-normal text-gray-700">
          {data?.description}
        </p>
      </div>

      <div className=" absolute left-4 md:left-8 bottom-4 flex items-center flex-wrap justify-start gap-2 ">
        <ApproveButton
          onClickButton={onClickSkip}
          is_approve={true}
          title={'Skip'}
        />
        <ApproveButton
          onClickButton={onMarkAsComplete}
          is_approve={true}
          title={'Mark as Completed'}
        />

        <SaveButton
          onClickButton={oncClickHandler}
          is_approve={true}
          title={data?.btn_title}
        />
      </div>
    </div>
  );
};

export default CardWithButton;
